/**
 * @file        strings.js
 *              Misc utility code for manipulating strings in JS.
 * @author      Wes Garland, wes@distributive.network
 * @date        Nov 2024
 *      
 * @todo replace calls throughout codebase to calls into this lib. /wg nov 2024
 * @todo eliminate camel-case npm library
 */
'use strict';

const { getenv } = require('dcp/common/dcp-env');
const isDebugBuild = require('dcp/common/dcp-build').build === 'debug';

/* kebab to camel case */
exports.k2cCase = function k2cCase(kebab)
{
  return kebab.replace(/(-)([a-z])/g, (ignore, dash, char) => char.toUpperCase());
}

/* camel to kebab case */
exports.c2kCase = function c2kCase(camel)
{
  return camel.replace(/([A-Z])/g, match => '-' + match.toLowerCase());
}

/** Charset used for exports.randStr21() */
exports.randStrAlphabet = '1234567890abcdefghijklmnopqrstuvwyxzkABCDEFGHIJKLMNOPQRSTUVWXYZ';

/* Generate random 21-char strings - eg for opaqueId, dcpsid */
exports.randStr21 = require('nanoid').customAlphabet(exports.randStrAlphabet, 21);
if (isDebugBuild
    && getenv('DCP_DETERMINISTIC_RANDSTR21')
    && getenv('DCP_DETERMINISTIC_RANDSTR21') !== 'false')
{
  const hash = require('../common/hash');
  let seq=0;

  /* Generate nonces, ackTokens, etc deterministcally rather than randomly. This is useless from a
   * security POV, but very helpful when trying to compare the output from two different test runs. The
   * "random" string generated depends solely on what order it was generated.
   */
  exports.randStr21 = function deterministicRandStr21()
  {
    const alphabet = exports.randStrAlphabet;
    var id = ++seq + getenv('DCP_DETERMINISTIC_RANDSTR21') + alphabet[seq % alphabet.length];
    id += hash.calculate(hash.eh1, id).slice(4) + alphabet;
    return id.slice(0,21);
  }
}
